<app-dashboard-container [shareVisible]="false" [factTable]="factTable" [exportTypes]="[]">
	<app-filter-panel
		[defaultFilters]="defaultFilters"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijferkolommen"
		[permanentFilterExpressions]="permanentFilterExpressions"
		[leerlingselectie]="false"
	></app-filter-panel>
	<app-filter-bar></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header></app-dashboard-header>
		<app-barchart-table
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilterExpressions"
			[groups]="selectedGroups"
			[config]="this"
		></app-barchart-table>
	</section>
</app-dashboard-container>
